<h2 mat-dialog-title class="modal-title">
    <mat-icon class="notification-icon">notifications</mat-icon>
    Notificação
</h2>

<mat-dialog-content class="modal-content">
    <div class="notification-header">
        <div class="avatar">
            <mat-icon>person</mat-icon>
        </div>
        <div class="user-info">
            <p class="user"><strong>{{ data.userInfo?.name || 'Sistema'
                    }}</strong></p>
            <p class="user-type" *ngIf="data.userInfo">
                <span *ngIf="data.userInfo.partnerId">Parceiro</span>
                <span *ngIf="data.userInfo.customerId">Cliente</span>
                <span *ngIf="data.userInfo.userId">Usuário</span>
            </p>
            <p class="date">{{ data.createdAt | date:'dd/MM/yyyy HH:mm' }}</p>
        </div>
    </div>

    <p *ngIf="data.system" class="system">
        <strong>Sistema:</strong> {{ data.system?.name }}
    </p>

    <p *ngIf="data.status" class="status">
        <span class="status-label {{ getStatusClass(data.status) }}">
            <mat-icon class="status-icon">{{ getStatusIcon(data.status)
                }}</mat-icon>
            {{ data.status }}
        </span>
    </p>

    <p class="message">{{ data.message }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()" color="primary">
        <mat-icon>close</mat-icon>
        Fechar
    </button>
</mat-dialog-actions>
